import { Component, Input } from '@angular/core';

@Component({
    selector: 'gc-reissued-payment-text',
    templateUrl: './reissued-payment-text.component.html',
    styleUrls: ['./reissued-payment-text.component.scss'],
    standalone: false
})
export class ReissuedPaymentTextComponent {
  @Input() reissuedInPaymentId: number;
  @Input() reissuedForPaymentId: number;
}
